import React, { useContext, useEffect } from 'react';
import * as Yup from 'yup';
import { LeReacteurContext } from '../../Layout';
import MoonLoader from 'react-spinners/MoonLoader';
/* --- import components ----*/
import { BackButton, ErrorMessage, MultiSelectSmall } from '../../Form';
import { Form, Formik } from 'formik';
import { FormContainer, PerksWrapper, Wrapper } from '../elements';
import { InputForm, Label, NextBtn, Sublabel, TextareaForm } from '../../Form/elements';
import { Paragraph } from 'src/components/Typography';

import CheckboxComp from 'src/components/EmailForm/CheckboxComp';
/* --- import utils ----*/
import { useRestoreFormManager } from 'src/utils/RestoreForm';
/* --- import style ----*/
import colors from 'src/style/colors';
import Perks from '../Perks';

const FORM_TOKEN = 'apply-step3';

const ThirdBlock = ({ onBackClicked, onSubmit, error, GRCtoken, isLoading, stepsData }) => {
  const isLong = stepsData.step1.offerType === 'long';
  const isAlternance = stepsData.step1.formation === 'Alternance';
  const ThirdBlockSchema = Yup.object().shape({
    franceTravail:
      isLong && !isAlternance ? Yup.string().required('Champ obligatoire') : Yup.string(),
    franceTravailId: Yup.string(),
    postalCode: Yup.string().required('Champ obligatoire'),
    why: isLong ? Yup.string().required('Champ obligatoire') : Yup.string(),
    optIn: Yup.string()
      .nullable()
      .oneOf(['Oui'], 'Veuillez cocher cette case')
      .required('Veuillez cocher cette case'),
    handicap: Yup.string().nullable(),
    hasRncp5Graduation: isAlternance
      ? Yup.boolean().nullable().required('Champ obligatoire')
      : Yup.boolean().nullable(),
    hasAlternanceCompany: isAlternance
      ? Yup.boolean().nullable().required('Champ obligatoire')
      : Yup.boolean().nullable(),
    alternanceCompanyName: Yup.string().when('hasAlternanceCompany', {
      is: true,
      then: (schema) => (isAlternance ? schema.required('Champ obligatoire') : schema),
    }),
  });

  const { dtlVirtualPageView } = useContext(LeReacteurContext);
  const manager = useRestoreFormManager();
  const initialValues = {
    franceTravail: '',
    franceTravailId: '',
    postalCode: '',
    why: '',
    optIn: null,
    handicap: null,
    hasRncp5Graduation: null,
    hasAlternanceCompany: null,
    alternanceCompanyName: '',
    csp: '',
    rsa: '',
    cdiTwoYears: '',
    transitionsPro: '',
    ...(manager.get(FORM_TOKEN) || {}),
  };

  if (stepsData.step1.certification === 'RNCP5') {
    initialValues.hasRncp5Graduation = false;
  }

  useEffect(() => {
    if (window) {
      window.scrollTo({
        top: 90,
        left: 0,
        behavior: 'smooth',
      });
    } else {
      return null;
    }
  }, []);
  useEffect(() => {
    dtlVirtualPageView('bootcamp', '3', 'Pré-requis');
  }, []);

  return (
    <FormContainer>
      <Formik
        initialValues={initialValues}
        validationSchema={ThirdBlockSchema}
        validateOnMount={true}
        onSubmit={(values) => {
          const {
            why,
            optIn,
            handicap,
            hasRncp5Graduation,
            hasAlternanceCompany,
            alternanceCompanyName,
            franceTravail,
            franceTravailId,
            postalCode,
          } = values;
          manager.set(FORM_TOKEN, values);

          let specialStatus = '';
          if (values.csp === 'Oui') {
            specialStatus = 'CSP';
          } else if (values.transitionsPro === 'Oui') {
            specialStatus = 'TRANSITIONS PRO';
          } else if (
            values.rsa === 'Oui' &&
            values.postalCode &&
            values.postalCode.startsWith('93')
          ) {
            specialStatus = 'DÉPARTEMENT';
          }

          const answers = {
            franceTravail,
            franceTravailId,
            postalCode,
            why,
            optIn,
            handicap,
            hasRncp5Graduation,
            hasAlternanceCompany,
            alternanceCompanyName,
          };

          if (specialStatus) {
            answers.specialStatus = specialStatus;
          }

          onSubmit(answers);
          window.dataLayer.push({
            event: 'bootcampPrerequisite',
            optIn,
          });
        }}
      >
        {({ errors, handleChange, setFieldValue, touched, values, isSubmitting }) => {
          const isDisabled = () => {
            try {
              ThirdBlockSchema.validateSync(values);
              return false;
            } catch (error) {
              return true;
            }
          };

          const specialStatus = (() => {
            if (values.csp === 'Oui') return 'CSP';
            if (values.transitionsPro === 'Oui') return 'TRANSITIONS PRO';
            if (values.rsa === 'Oui' && values.postalCode?.startsWith('93')) return 'DÉPARTEMENT';
            return undefined;
          })();

          return (
            <>
              <Form
                css={{
                  maxWidth: isSubmitting ? '' : 546,
                  width: isSubmitting ? 'none' : '100%',
                  minWidth: isSubmitting ? '100%' : '',
                  margin: isSubmitting ? 'auto' : '',
                }}
              >
                {isLoading ? (
                  <Wrapper>
                    <MoonLoader color={colors.purple} size={20} />
                  </Wrapper>
                ) : error ? (
                  <Wrapper>
                    <Paragraph css={{ padding: 0 }}>
                      Une erreur est survenue, merci de réessayer ultérieurement ou de nous
                      contacter si le problème persiste.
                    </Paragraph>
                  </Wrapper>
                ) : (
                  <>
                    {process.env.NODE_ENV === 'development' && (
                      <pre
                        css={{
                          backgroundColor: 'rgba(0,0,0,0.8)',
                          color: 'white',
                          padding: 10,
                          width: 400,
                          maxWidth: '90vw',
                          maxHeight: '80vh',
                          whiteSpace: 'pre-wrap',
                          overflow: 'auto',
                          wordWrap: 'break-word',
                          position: 'fixed',
                          top: 100,
                          right: 20,
                          zIndex: 2000,
                          borderRadius: 5,
                          fontSize: 12,
                        }}
                      >
                        {JSON.stringify({ ...stepsData, ...values, specialStatus }, null, 2)}
                      </pre>
                    )}
                    {/* has RNCP5  */}
                    {stepsData.step1.certification === 'RNCP6' && (
                      <div css={{ marginBottom: 50 }}>
                        <Label css={{ paddingBottom: 10 }}>
                          Êtes-vous déjà titulaire d’un titre RNCP de niveau 5 (Bac+2) dans le
                          domaine du développement ?
                        </Label>
                        <div data-cy="rncp5" css={{ display: 'flex' }}>
                          <MultiSelectSmall
                            isSelected={values.hasRncp5Graduation}
                            onClick={() => {
                              setFieldValue('hasRncp5Graduation', true);
                            }}
                          >
                            Oui
                          </MultiSelectSmall>
                          <MultiSelectSmall
                            isLeft
                            isSelected={values.hasRncp5Graduation === false}
                            onClick={() => {
                              setFieldValue('hasRncp5Graduation', false);
                            }}
                          >
                            Non
                          </MultiSelectSmall>
                        </div>
                        <ErrorMessage
                          isVisible={errors.hasRncp5Graduation && touched.hasRncp5Graduation}
                          message={errors.hasRncp5Graduation}
                        />
                      </div>
                    )}

                    {/* ENTREPRISE D'ACCUEIL  */}
                    {stepsData.step1.certification === 'RNCP6' &&
                      stepsData.step1.formation === 'Alternance' &&
                      values.hasRncp5Graduation !== null && (
                        <div css={{ marginBottom: 50 }}>
                          <Label css={{ paddingBottom: 0 }}>
                            Avez-vous trouvé une entreprise prête à vous accueillir ?
                          </Label>
                          {!values.hasRncp5Graduation && (
                            <Sublabel>
                              Sans entreprise d'accueil et expérience en programmation préalable, il
                              sera très complexe de vous intégrer dans un cursus en alternance.{' '}
                              <b>
                                Une formation en amont (de type bootcamp ou e-learning) est
                                fortement recommandée.
                              </b>
                            </Sublabel>
                          )}
                          <div css={{ display: 'flex' }}>
                            <MultiSelectSmall
                              isSelected={values.hasAlternanceCompany === true}
                              onClick={() => {
                                setFieldValue('hasAlternanceCompany', true);
                              }}
                            >
                              Oui
                            </MultiSelectSmall>
                            <MultiSelectSmall
                              isLeft
                              isSelected={values.hasAlternanceCompany === false}
                              onClick={() => {
                                setFieldValue('hasAlternanceCompany', false);
                              }}
                            >
                              Non
                            </MultiSelectSmall>
                          </div>
                          <ErrorMessage
                            isVisible={errors.hasAlternanceCompany && touched.hasAlternanceCompany}
                            message={errors.hasAlternanceCompany}
                          />

                          {/* ALTERNANCE COMPANY NAME */}
                          {values.hasAlternanceCompany && (
                            <div css={{ marginTop: 50 }}>
                              <Label>Quel est le nom de l'entreprise en question ?</Label>
                              <InputForm
                                name="alternanceCompanyName"
                                onChange={handleChange}
                                value={values.alternanceCompanyName}
                                errorStyle={
                                  errors.alternanceCompanyName && touched.alternanceCompanyName
                                    ? true
                                    : false
                                }
                              />
                              <ErrorMessage
                                isVisible={
                                  errors.alternanceCompanyName && touched.alternanceCompanyName
                                }
                                message={errors.alternanceCompanyName}
                              />
                            </div>
                          )}
                        </div>
                      )}

                    {/* Inscription à France Travail */}
                    {stepsData.step1.formation !== 'Alternance' &&
                      stepsData.step1.offerType !== 'short' && (
                        <div css={{ marginBottom: 50 }}>
                          <Label css={{ paddingBottom: 0 }}>
                            Êtes-vous inscrit(e) à France Travail ?
                          </Label>
                          <Sublabel>
                            Nous aimerions savoir si vous êtes potentiellement éligible à un
                            financement.
                          </Sublabel>
                          <div css={{ display: 'flex' }}>
                            <MultiSelectSmall
                              isSelected={values.franceTravail === 'Oui'}
                              onClick={() => {
                                const newValue = values.franceTravail !== 'Oui' ? 'Oui' : '';
                                setFieldValue('franceTravail', newValue);
                                // When switching to France Travail, reset the other path
                                if (newValue === 'Oui') {
                                  setFieldValue('cdiTwoYears', '');
                                  setFieldValue('transitionsPro', '');
                                }
                              }}
                            >
                              Oui
                            </MultiSelectSmall>
                            <MultiSelectSmall
                              isLeft
                              isSelected={values.franceTravail === 'Non'}
                              onClick={() => {
                                const newValue = values.franceTravail !== 'Non' ? 'Non' : '';
                                setFieldValue('franceTravail', newValue);
                                // When switching to NOT France Travail, reset the FT path
                                if (newValue === 'Non') {
                                  setFieldValue('franceTravailId', '');
                                  setFieldValue('csp', '');
                                  setFieldValue('rsa', '');
                                }
                              }}
                            >
                              Non
                            </MultiSelectSmall>
                          </div>
                          <ErrorMessage
                            isVisible={errors.franceTravail && touched.franceTravail}
                            message={errors.franceTravail}
                          />

                          {/* Identifiant France Travail */}
                          {values.franceTravail === 'Oui' && (
                            <div css={{ marginTop: 50 }}>
                              <Label css={{ paddingBottom: 10 }}>
                                Quel est votre identifiant France Travail ?
                              </Label>
                              <Sublabel>Il est normalement composé de 11 chiffres.</Sublabel>
                              <InputForm
                                name="franceTravailId"
                                onChange={handleChange}
                                value={values.franceTravailId}
                                errorStyle={
                                  errors.franceTravailId && touched.franceTravailId ? true : false
                                }
                              />
                              <ErrorMessage
                                isVisible={errors.franceTravailId && touched.franceTravailId}
                                message={errors.franceTravailId}
                              />
                            </div>
                          )}

                          {/* CSP */}
                          {values.franceTravail === 'Oui' && (
                            <div css={{ marginTop: 50 }}>
                              <Label css={{ paddingBottom: 0 }}>
                                Bénéficiez-vous du Contrat de Sécurisation Professionnelle (CSP) ?
                              </Label>
                              <Sublabel>
                                Le CSP est proposé en cas de licenciement économique pour vous aider
                                à retrouver rapidement un emploi.
                              </Sublabel>
                              <div css={{ display: 'flex' }}>
                                <MultiSelectSmall
                                  isSelected={values.csp === 'Oui'}
                                  onClick={() => {
                                    const newValue = values.csp !== 'Oui' ? 'Oui' : '';
                                    setFieldValue('csp', newValue);
                                    // If user is in CSP, no need to ask for RSA
                                    if (newValue === 'Oui') {
                                      setFieldValue('rsa', '');
                                    }
                                  }}
                                >
                                  Oui
                                </MultiSelectSmall>
                                <MultiSelectSmall
                                  isLeft
                                  isSelected={values.csp === 'Non'}
                                  onClick={() => {
                                    setFieldValue('csp', values.csp !== 'Non' ? 'Non' : '');
                                  }}
                                >
                                  Non
                                </MultiSelectSmall>
                              </div>
                              <ErrorMessage
                                isVisible={errors.csp && touched.csp}
                                message={errors.csp}
                              />
                            </div>
                          )}

                          {/* RSA */}
                          {values.franceTravail === 'Oui' && values.csp === 'Non' && (
                            <div css={{ marginTop: 50 }}>
                              <Label css={{ paddingBottom: 0 }}>Êtes-vous titulaire du RSA ?</Label>
                              <Sublabel>
                                Cette information nous aide à identifier les aides financières
                                auxquelles vous pourriez avoir droit.
                              </Sublabel>
                              <div css={{ display: 'flex' }}>
                                <MultiSelectSmall
                                  isSelected={values.rsa === 'Oui'}
                                  onClick={() => {
                                    setFieldValue('rsa', values.rsa !== 'Oui' ? 'Oui' : '');
                                  }}
                                >
                                  Oui
                                </MultiSelectSmall>
                                <MultiSelectSmall
                                  isLeft
                                  isSelected={values.rsa === 'Non'}
                                  onClick={() => {
                                    setFieldValue('rsa', values.rsa !== 'Non' ? 'Non' : '');
                                  }}
                                >
                                  Non
                                </MultiSelectSmall>
                              </div>
                              <ErrorMessage
                                isVisible={errors.rsa && touched.rsa}
                                message={errors.rsa}
                              />
                            </div>
                          )}

                          {/* CDI 2 ans */}
                          {values.franceTravail === 'Non' && (
                            <div css={{ marginTop: 50 }}>
                              <Label css={{ paddingBottom: 0 }}>
                                Êtes-vous en CDI dans la même entreprise depuis au moins 2 ans ?
                              </Label>
                              <Sublabel>
                                Cette condition est souvent requise pour bénéficier de certains
                                dispositifs de financement comme Transitions Pro.
                              </Sublabel>
                              <div css={{ display: 'flex' }}>
                                <MultiSelectSmall
                                  isSelected={values.cdiTwoYears === 'Oui'}
                                  onClick={() => {
                                    setFieldValue(
                                      'cdiTwoYears',
                                      values.cdiTwoYears !== 'Oui' ? 'Oui' : ''
                                    );
                                  }}
                                >
                                  Oui
                                </MultiSelectSmall>
                                <MultiSelectSmall
                                  isLeft
                                  isSelected={values.cdiTwoYears === 'Non'}
                                  onClick={() => {
                                    const newValue = values.cdiTwoYears !== 'Non' ? 'Non' : '';
                                    setFieldValue('cdiTwoYears', newValue);
                                    // If user is not in CDI for 2 years, no Transitions Pro
                                    if (newValue === 'Non') {
                                      setFieldValue('transitionsPro', '');
                                    }
                                  }}
                                >
                                  Non
                                </MultiSelectSmall>
                              </div>
                              <ErrorMessage
                                isVisible={errors.cdiTwoYears && touched.cdiTwoYears}
                                message={errors.cdiTwoYears}
                              />
                            </div>
                          )}

                          {/* Transitions Pro */}
                          {values.franceTravail === 'Non' && values.cdiTwoYears === 'Oui' && (
                            <div css={{ marginTop: 50 }}>
                              <Label css={{ paddingBottom: 0 }}>
                                Comptez-vous utiliser le dispositif Transitions Pro ?
                              </Label>
                              <Sublabel>
                                Transitions Pro est un dispositif qui peut financer votre formation.
                                Faites-nous part de vos intentions.
                              </Sublabel>
                              <div css={{ display: 'flex' }}>
                                <MultiSelectSmall
                                  isSelected={values.transitionsPro === 'Oui'}
                                  onClick={() => {
                                    setFieldValue(
                                      'transitionsPro',
                                      values.transitionsPro !== 'Oui' ? 'Oui' : ''
                                    );
                                  }}
                                >
                                  Oui
                                </MultiSelectSmall>
                                <MultiSelectSmall
                                  isLeft
                                  isSelected={values.transitionsPro === 'Non'}
                                  onClick={() => {
                                    setFieldValue(
                                      'transitionsPro',
                                      values.transitionsPro !== 'Non' ? 'Non' : ''
                                    );
                                  }}
                                >
                                  Non
                                </MultiSelectSmall>
                                <MultiSelectSmall
                                  isLeft
                                  isSelected={values.transitionsPro === 'Je ne sais pas'}
                                  onClick={() => {
                                    setFieldValue(
                                      'transitionsPro',
                                      values.transitionsPro !== 'Je ne sais pas'
                                        ? 'Je ne sais pas'
                                        : ''
                                    );
                                  }}
                                >
                                  Je ne sais pas
                                </MultiSelectSmall>
                              </div>
                              <ErrorMessage
                                isVisible={errors.transitionsPro && touched.transitionsPro}
                                message={errors.transitionsPro}
                              />
                            </div>
                          )}
                        </div>
                      )}

                    {/* Code Postal */}
                    <div css={{ marginBottom: 50 }}>
                      <Label css={{ paddingBottom: 10 }}>Quel est votre code postal ?</Label>
                      <InputForm
                        name="postalCode"
                        onChange={(e) => {
                          const newValue = e.target.value.replace(/[^0-9]/g, '');
                          setFieldValue('postalCode', newValue);
                        }}
                        errorStyle={errors.postalCode && touched.postalCode ? true : false}
                        value={values.postalCode}
                      />
                      <ErrorMessage
                        isVisible={errors.postalCode && touched.postalCode}
                        message={errors.postalCode}
                      />
                    </div>
                    <div css={{ marginBottom: 50 }}>
                      <Label css={{ paddingBottom: 0 }}>
                        {stepsData.step1.offerType === 'short'
                          ? `Souhaitez-vous aborder des sujets techniques particuliers ?`
                          : `Pourquoi souhaitez-vous suivre une formation de ce type ?`}
                      </Label>
                      <Sublabel>
                        {stepsData.step1.offerType === 'short'
                          ? `Si c'est le cas, vous pouvez tout nous lister ici.`
                          : `Expliquez-nous votre intérêt pour cette formation, nous sommes curieux d'en
                    savoir plus sur votre motivation.`}
                      </Sublabel>
                      <TextareaForm
                        type="why"
                        name="why"
                        errorStyle={errors.why && touched.why ? true : false}
                        value={values.why}
                        onChange={handleChange}
                      />
                      <ErrorMessage isVisible={errors.why && touched.why} message={errors.why} />
                    </div>

                    {/* handicap  */}
                    <div css={{ marginBottom: 50 }}>
                      <Label css={{ paddingBottom: 0 }}>Avez-vous des besoins spécifiques ?</Label>
                      <Sublabel>
                        Par exemple, des besoins liés à une situation de handicap. Nous vérifierons
                        ensemble comment vous proposer l'accompagnement le plus adapté possible.
                      </Sublabel>

                      <div data-cy="needs" css={{ display: 'flex' }}>
                        <MultiSelectSmall
                          isSelected={values.handicap === 'Oui'}
                          onClick={() => {
                            setFieldValue('handicap', values.handicap !== 'Oui' ? 'Oui' : '');
                          }}
                        >
                          Oui
                        </MultiSelectSmall>
                        <MultiSelectSmall
                          isLeft
                          isSelected={values.handicap === 'Non'}
                          onClick={() => {
                            setFieldValue('handicap', values.handicap !== 'Non' ? 'Non' : '');
                          }}
                        >
                          Non
                        </MultiSelectSmall>
                      </div>
                      <ErrorMessage
                        isVisible={errors.handicap && touched.handicap}
                        message={errors.handicap}
                      />
                    </div>

                    {/* OPTIN  */}
                    <div css={{ marginTop: 50 }}>
                      <CheckboxComp
                        text="J'accepte que Le Reacteur me recontacte par mail."
                        value={values.optIn === 'Oui' ? true : false}
                        onChange={() => {
                          setFieldValue('optIn', values.optIn !== 'Oui' ? 'Oui' : '');
                        }}
                        errorDisabled={false}
                        errorIsVisible={errors.optIn && touched.optIn}
                        errorMessage={errors.optIn}
                      />
                    </div>
                  </>
                )}

                {/* SUBMIT  */}
                <div
                  css={{
                    display: 'flex',
                    alignItems: 'baseline',
                    justifyContent: isSubmitting ? 'center' : 'space-between',
                  }}
                >
                  {isSubmitting ? null : (
                    <BackButton
                      onClick={() => {
                        manager.set(FORM_TOKEN, values);
                        onBackClicked();
                      }}
                    />
                  )}
                  <div
                    onClick={() => {
                      if (isDisabled()) {
                        try {
                          ThirdBlockSchema.validateSync(values, { abortEarly: false });
                        } catch (e) {
                          console.log(
                            'Champs manquants :',
                            e.inner.map((err) => ({ [err.path]: err.message }))
                          );
                        }
                      }
                    }}
                  >
                    <NextBtn
                      type="submit"
                      disabledStyle={isSubmitting || isDisabled()}
                      disabled={isSubmitting}
                    >
                      Envoyer
                    </NextBtn>
                  </div>
                </div>
              </Form>
              {!isSubmitting && (
                <PerksWrapper>
                  <Perks
                    offerType={stepsData.step1.offerType}
                    courseType={stepsData.step1.courseType}
                    certification={stepsData.step1.certification}
                    format={stepsData.step1.format}
                    rncpFunding={stepsData.step1.rncpFunding}
                  />
                </PerksWrapper>
              )}
            </>
          );
        }}
      </Formik>
    </FormContainer>
  );
};

export default ThirdBlock;
